import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
var FilterOption = function FilterOption(_ref) {
  var id = _ref.id,
    isActive = _ref.isActive,
    name = _ref.name,
    _onChange = _ref.onChange,
    option = _ref.option;
  var label = option.label;
  var filterOptionClass = function filterOptionClass() {
    return classNames({
      'regular-font': true,
      'hover:border-l-2 hover:border-united-blue hover:pl-4.5 pl-5 border-solid hover:bg-medium-fill-blue': !option.hasChildren,
      'border-l-2 border-united-blue pl-4.5': isActive,
      'py-2 px-2.5 pb-0 uppercase': option.hasChildren
    });
  };
  if (_.get(option, 'hasChildren', false)) {
    return /*#__PURE__*/React.createElement("div", {
      className: filterOptionClass()
    }, /*#__PURE__*/React.createElement("span", null, label));
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    React.createElement("div", {
      className: filterOptionClass(),
      "aria-label": label,
      tabIndex: 0
    }, /*#__PURE__*/React.createElement("label", {
      className: "pt-3 pl-2.5 pb-2.5 text-initial box-content block font-regular-font capitalize text-sm text-brand-blue tracking-normal",
      htmlFor: "".concat(id)
    }, /*#__PURE__*/React.createElement("input", {
      checked: isActive === option.value,
      id: "".concat(id),
      name: name,
      onChange: function onChange(e) {
        return _onChange(option, e.target.value);
      },
      type: "radio",
      value: option.value,
      className: "hidden"
    }), /*#__PURE__*/React.createElement("span", {
      id: "".concat(id, "-label")
    }, label)))
  );
};
FilterOption.propTypes = {
  id: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  option: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
};
export default FilterOption;